export default __webpack_public_path__ + "static/media/login-active.36b61111.svg";